import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7535528a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { action: "" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-monitor-camera-full" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-bofang" }, null, -1))

import { ref, watch } from 'vue'

import { getStoreDevice } from '@/api/shop'
import { IDevice } from '@/utils/interface'


export default /*#__PURE__*/_defineComponent({
  props: {
  storeNo: {
    type: String,
    required: true
  }
},
  emits: ['handle'],
  setup(__props, { emit }) {

const props = __props

const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)
const curPage = ref(1)
const curSize = ref(30)
const startTime = ref('')
const endTime = ref('')
const list = ref<IDevice[]>([])
const value = ref<string>('')
const total = ref(0)




watch(
  () => props.storeNo,
  () => {
    onSearch()
  }
)

const curIndex = ref(0)
const toPlay = (item: IDevice, index: number) => {
  emit('handle', item, true)
  curIndex.value = index
}

const onSearch = () => {
  refreshing.value = true
  onRefresh()
}

const onLoad = () => {
  if (refreshing.value) {
    list.value = []
    refreshing.value = false
    curPage.value = 1
  }
  setTimeout(() => {
    getStoreDevice({
      storeNo: props.storeNo,
      // startTime: startTime.value,
      // endTime: endTime.value,
      page: curPage.value,
      size: curSize.value,
      deviceName: value.value
    }).then((res: any) => {
      if (curPage.value === 1) {
        list.value = res.deviceList
        emit('handle', list.value[0], true)
      } else {
        list.value = list.value.concat(res.deviceList)
      }
      loading.value = false
      total.value = res.row
      if (list.value.length >= res.row) {
        finished.value = true
      } else {
        curPage.value += 1
      }
    })
  }, 500)
}

const onRefresh = () => {
  // 清空列表数据
  finished.value = false

  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true
  onLoad()
}

return (_ctx: any,_cache: any) => {
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_divider, { style: { color: '#D1D1D1', borderColor: '#D1D1D1', margin: '12px 54px' } }, {
      default: _withCtx(() => [
        _createTextVNode("共" + _toDisplayString(total.value) + "个监控设备", 1)
      ]),
      _: 1
    }),
    _createElementVNode("form", _hoisted_1, [
      _createVNode(_component_van_search, {
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        shape: "round",
        background: "#fff",
        placeholder: "输入设备名称搜索...",
        "left-icon": "",
        "right-icon": "search",
        onSearch: onSearch,
        onClickRightIcon: onSearch
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了",
          class: "monitor-list",
          offset: "5",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (toPlay(item, index)),
                class: _normalizeClass([curIndex.value === index ? 'actived' : '']),
                key: index
              }, [
                _hoisted_3,
                _createElementVNode("p", null, _toDisplayString(item.deviceName), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(['state', item.deviceStatus === '1' ? 'success' : ''])
                }, _toDisplayString(item.deviceStatus === '1' ? '在线' : '掉线'), 3),
                _hoisted_4
              ], 10, _hoisted_2))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})